"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validSectionText = exports.validSection = exports.SECTION_NAME_MAX_LENGTH = void 0;
const instance_1 = __importDefault(require("./instance"));
const errorMessageGenerator_1 = require("../utils/errorMessageGenerator");
exports.SECTION_NAME_MAX_LENGTH = 255;
exports.validSection = instance_1.default.object().shape({
    name: instance_1.default
        .string()
        .required(errorMessageGenerator_1.requiredError)
        .max(exports.SECTION_NAME_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(exports.SECTION_NAME_MAX_LENGTH))
});
exports.validSectionText = instance_1.default.object().shape({
    text: instance_1.default
        .string()
        .required(errorMessageGenerator_1.requiredError)
        .max(exports.SECTION_NAME_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(exports.SECTION_NAME_MAX_LENGTH))
});
//# sourceMappingURL=section.js.map